export default "__VITE_ASSET__uG8dUuwo__"